<template>
  <div class="zf-layout">
    <div class="title" :class="[required ? 'is-required' : '']">
      <span>{{ title }} <span v-if="subTitle" class="title_tips c9 fs12 ml10">{{ subTitle }}</span></span>
      <span><slot name="right" /></span>
    </div>
    <div class="body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '基本信息'
    },
    subTitle: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.zf-layout{
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  margin-bottom: 30px;
  .title{
    height: 44px;
    line-height: 44px;
    font-weight: bold;
    border-bottom: 1px solid #e8e8e8;
    background-color: #FAFAFA;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
  }
  .is-required{
    &>span:first-child::before{
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
    }
  }
  .body{
    padding: 16px 24px;
  }
}
</style>
